// External libraries
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// React
import React, { useEffect } from 'react';

// Local imports
import { RootState } from '../../redux/store';

interface AuthLayoutProps {
    children: React.ReactNode;
}

const AuthenticatedLayout = ({ children }: AuthLayoutProps): JSX.Element => {
    const user = useSelector((state: RootState) => state.user.user);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/');
        }
    }, [user, navigate]);

    return <>{children}</>;
};

export default AuthenticatedLayout;